<template>
    <div class="container-detail" v-if="loading">
        <div class="detail-header-buttons">
            <v-btn @click="back" style="width: auto !important" class="button-accept">
                <v-icon>mdi-chevron-left</v-icon>
                Вернуться к списку новостей
            </v-btn>

            <v-btn @click="goToEdit" style="width: auto !important" class="button-action">
                Редактировать
            </v-btn>
        </div>

        <div class="detail-main">
            <div class="detail-main-first-container">
                <div class="first-container-box" v-if="news && news.name">
                    <div class="container-box-title">
                        Заголовок
                    </div>
                    <div class="container-box-text">
                        {{ news.name }}
                    </div>
                </div>
                <div class="first-container-box" v-if="newsCategories.length">
                    <div class="container-box-title">
                        Категории
                    </div>
                    <div class="container-box-text">
                        <div v-for="item in newsCategories" :key="item.id || item.name">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div class="first-container-box" v-if="news && news.fullText">
                    <div class="container-box-title">
                        Текст новости
                    </div>
                    <div class="container-box-text" v-html="news.fullText">

                    </div>
                </div>
                <div class="first-container-box" v-if="news && news.datePublished">
                    <div class="container-box-title">
                        Начало публикации
                    </div>
                    <div class="container-box-text">
                        {{ news.datePublished | moment("DD.MM.YYYY HH:mm") }}
                    </div>
                </div>

                <div class="first-container-box" v-if="news && news.transition">
                    <div class="container-box-title">
                        Вид перехода
                    </div>
                    <div class="container-box-text">
                        <span v-if="news.transition.type == 'deeplink'">
                            Внутренний раздел
                        </span>
                        <span v-else-if="news.transition.type == 'url'">
                            Ссылка
                        </span>
                        <span v-else-if="news.transition.type == 'file' && !news.transition.path">
                            PDF файл
                        </span>
                        <span v-else-if="news.transition.type == 'file' && news.transition.path">
                            <v-icon>
                                mdi-file-pdf-box
                            </v-icon>

                            <a target="_blank" :href="news.transition.path">PDF файл</a>
                        </span>


                    </div>
                </div>
                <div class="first-container-box"
                    v-if="news && news.transition && news.transition.type && news.transition.type == 'url' && news.transition.path">
                    <div class="container-box-title">
                        Ссылка
                    </div>
                    <div class="container-box-text">
                        <a target="_blank" :href="news.transition.path">{{ news.transition.path }}</a>
                    </div>
                </div>
                <div class="first-container-box"
                    v-if="news && news.transition && news.transition.type && news.transition.type == 'deeplink' && news.appSection">
                    <div class="container-box-title">
                        Раздел выбранный для перехода
                    </div>
                    <div class="container-box-text">
                        {{ news.appSection.name }}
                    </div>
                </div>
                <div class="first-container-box"
                    v-if="news && news.transition && news.transition.type && news.transition.type == 'deeplink' && news.transition.buttonName">
                    <div class="container-box-title">
                        Название кнопки
                    </div>
                    <div class="container-box-text">
                        {{ news.transition.buttonName }}
                    </div>
                </div>




            </div>
            <div class="detail-main-second-container">
                <div class="second-container-box">
                    <div class="container-box-title">
                        Фон баннера
                    </div>
                    <div class="container-box-text">
                        Нажмите на изображение, чтобы увидеть его в полном размере
                    </div>
                </div>

                <div>
                    <v-simple-table v-if="news">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Формат
                                    </th>
                                    <th class="text-left">
                                        Место отображенния
                                    </th>
                                    <th class="text-left">
                                        Для смартфонов
                                    </th>
                                    <th class="text-left">
                                        Для планшетов
                                    </th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr style="height: 60px;">
                                    <td class="text-left">Главное изображение</td>
                                    <td class="text-left">Отображается внутри новости и когда включен режим «Главная
                                        новость»</td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(news.smartphoneMainImage)"
                                            v-if="news.smartphoneMainImage" class="table-img"
                                            :src="news.smartphoneMainImage">
                                    </td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(news.tabletMainImage)" v-if="news.tabletMainImage"
                                            class="table-img" :src="news.tabletMainImage">
                                    </td>
                                </tr>
                                <tr style="height: 60px;">
                                    <td class="text-left">Миниатюра</td>
                                    <td class="text-left">Отображается рядом с заголовком в списке новостей</td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(news.smartphoneMiniImage)"
                                            v-if="news.smartphoneMiniImage" class="table-img"
                                            :src="news.smartphoneMiniImage">
                                    </td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(news.tabletMiniImage)" v-if="news.tabletMiniImage"
                                            class="table-img" :src="news.tabletMiniImage">
                                    </td>
                                </tr>



                            </tbody>
                        </template>
                    </v-simple-table>

                    <DialogImage v-if="previewImage" v-model="dialogImg" :src="previewImage" />
                    <v-divider></v-divider>
                </div>

                <div class="second-container-box" style="margin-top: 40px" v-if="news">
                    <div class="container-box-title">
                        Параметры публикации и отображения
                    </div>
                    <div v-if="!news.toShowInNews && !news.toShowOnMainScreen">
                        Новость скрыта
                    </div>

                    <div v-if="news.toHead" class="container-box-onlytext">
                        Главная новость - Первая в списке и с большим изображением
                    </div>

                    <div v-if="news.mustSendPush" class="container-box-onlytext">
                        Отправить Push-уведомление при публикации новости
                    </div>

                    <div v-if="news.toShowOnMainScreen" class="container-box-onlytext">
                        Отображать на главном экране
                    </div>
                    <div v-if="news.toShowInNews" class="container-box-onlytext">
                        Отображать в разделе "Новости"
                    </div>
                    <div v-if="news.toShowInConference" class="container-box-onlytext">
                        Выводить на сайте конференции
                    </div>
                    <!-- <div v-if="news.isTimezoneRequired" class="container-box-onlytext">
                       Учитывать временные зоны
                    </div> -->


                </div>
                <div class="second-container-box" style="margin-top: 40px" v-if="news.pushId">
                    <div class="container-box-title">
                        Push-уведомление
                    </div>
                    <div class="container-box-text">
                    Дата отправки: {{ news.pushSendingDate | moment("DD.MM.YYYY HH:mm") }}
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>

export default {

    data: () => ({
        news: null,
        dialogImg: false,
        previewImage: null,
        imageWidth: 0,
        loading: false,

    }),
    computed: {
        newsCategories() {
            if (!this.news || !Array.isArray(this.news.categories)) {
                return []
            }

            return this.news.categories.filter(item => item && item.name)
        }
    },
    methods: {
        openDialogImg(src) {
            this.previewImage = src
            this.dialogImg = true
        },
        back() {
            this.$router.push({ name: 'News' })
        },
        goToEdit() {
            this.$router.push({ name: 'NewsEdit', params: { id: this.$route.params.id } })
        },
        getNews() {
            this.$axios.get(this.$store.getters.apiAdminPanelV5 + `/news/${this.$route.params.id}`, {
                headers: {
                    "secret-key": this.$store.state.secretKeyCookie,
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
            })
                .then(res => {
                    this.news = res.data
                    this.loading = true
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                    this.loading = true

                })

        }
    },
    created() {
        this.getNews()
    }
}
</script>
<style lang="scss" scoped>
.container-detail {
    box-sizing: border-box;
    padding: 40px !important;

    .detail-header-buttons {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
    }

    .detail-main {
        display: flex;
        justify-content: space-between;

        .detail-main-first-container {
            width: 48%;

            .first-container-box {

                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;
                    word-break: break-word;
                }

                .container-box-text-list {
                    .container-box-text-list-item {
                        display: flex;
                        margin-bottom: 5px;

                        .list-item-subtitle {
                            font-size: 16px;
                            font-weight: 600;
                            color: #929292;
                            width: 200px;
                        }

                        .list-item-text {
                            font-size: 18px;
                            font-weight: 400;
                        }

                    }
                }
            }
        }

        .detail-main-second-container {
            width: 48%;

            .table-img {
                cursor: pointer;
                height: 38px;
                object-fit: contain;
            }

            .second-container-box {
                width: 100%;
                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;
                    word-break: break-word;

                }

                .container-box-onlytext {
                    margin-top: 10px;
                }
            }
        }

    }
}
</style>
